import { useState, useEffect } from "react"
import { Calendar, MapPin, ArrowRight } from "lucide-react"
import { projectAPI } from "../services/projectService"
import ProjectCard from './ProjectCard';

function FeaturedProjects() {
  const [featuredProjects, setFeaturedProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchFeaturedProjects = async () => {
      try {
        setLoading(true)
        const data = await projectAPI.getRandomActiveProjects()
        setFeaturedProjects(data)
        setError(null)
      } catch (err) {
        console.error('Öne çıkan projeler yüklenirken hata:', err)
        setError('Öne çıkan projeler yüklenirken bir hata oluştu.')
        // Hata durumunda varsayılan verileri göster
        setFeaturedProjects([
          {
            title: "Lüks Villa Doğalgaz Tesisatı",
            city: "Beşiktaş",
            district: "İstanbul",
            year: "2024",
            description: "Modern villa için komple doğalgaz tesisat sistemi kurulumu. Merkezi sistem ve bireysel kombi montajı.",
            image_url: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=250",
            tags: ["Villa", "Merkezi Sistem", "Kombi"],
          },
          {
            title: "Apartman Doğalgaz Dönüşümü",
            city: "Kadıköy",
            district: "İstanbul",
            year: "2024",
            description: "24 daireli apartmanda kömürden doğalgaza dönüşüm projesi. Tüm izin işlemleri ve montaj dahil.",
            image_url: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=250",
            tags: ["Apartman", "Dönüşüm", "Toplu Konut"],
          },
          {
            title: "İşyeri Doğalgaz Sistemi",
            city: "Şişli",
            district: "İstanbul",
            year: "2023",
            description: "Ofis binası için doğalgaz tesisat kurulumu ve merkezi ısıtma sistemi montajı.",
            image_url: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=250",
            tags: ["İşyeri", "Merkezi Isıtma", "Ofis"],
          },
        ])
      } finally {
        setLoading(false)
      }
    }

    fetchFeaturedProjects()
  }, [])

  if (loading) {
    return (
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Öne çıkan projeler yükleniyor...</p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Öne Çıkan Projelerimiz</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Gerçekleştirdiğimiz başarılı projeler ile müşterilerimize güvenli ve kaliteli doğalgaz çözümleri sunuyoruz.
          </p>
          {error && (
            <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
              {error}
            </div>
          )}
          <a
            href="/projeler"
            className="inline-flex items-center px-6 py-3 text-blue-600 bg-transparent border border-blue-600 hover:bg-blue-50 rounded-md transition-colors duration-200"
          >
            Tüm Projeleri Görüntüle
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredProjects.map((project, index) => (
            <ProjectCard key={project.id || index} project={project} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturedProjects
